import { Injectable} from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { WorkflowService } from '@workflow/services/workflow.service';
import { EWorkflowPathKey } from '@app/pages/participant/workflow/workflow-path-key.enum';
import { map } from 'rxjs/operators';
import { participantPages } from '@app/pages/participant/participants.routes';

@Injectable({
	providedIn: 'root',
})
export class WorkflowGuard implements CanActivate {

	constructor(
		private workflowService: WorkflowService,
		private router: Router
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		const availableEntryPoint$ = this.workflowService.workflow$.pipe(
			map(wf => wf?.items?.find(item => item.id === route.params?.itemId)),
			// Solange wir _nicht_ auf eine Seite zugreifen wollen, welche disabled ist, gibt es Zugriff
			map(item => !(
				(item?.config?.disableOverview && route.data?.key === EWorkflowPathKey.OVERVIEW) ||
				(item?.config?.disableDetailPage && route.data?.key === EWorkflowPathKey.DETAIL)
			)),
		);
		availableEntryPoint$.subscribe(isAvailable => {
			if (isAvailable) return;

			this.router
				.navigate([participantPages.stammDaten.base()])
				.catch(console.error);
		});

		return availableEntryPoint$;
	}

}
